import { render, staticRenderFns } from "./AdminSegmentCampaigns.vue?vue&type=template&id=03c5d3ec&"
import script from "./AdminSegmentCampaigns.vue?vue&type=script&lang=js&"
export * from "./AdminSegmentCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports